const routes = [
    {
        path: '/organization/detail',
        component: function () {
            return import('@/components/admin/organization/DetailInfo')
        }
    },
    {
        path: '/organization/zh/list',
        component: function () {
            return import('@/components/admin/organization/ZhList')
        }
    },
    {
        path: '/organization/tw/data',
        component: function () {
            return import('@/components/admin/organization/TwData')
        }
    }
]

export default routes
